<template>
    <div class="apn-contact">
        <h2 class="message--msg">{{message}}</h2>
        <div class="quick-contact">
            <div class="contact-card">
                <h3>Yangon Office</h3>

                <div class="custom-list address">
                    <div class="contact-item">
                        <h3>address</h3>
                        <a href="https://www.google.com/maps/place/The+Leaf+Residence+%26+Tower/@16.847632,96.1177917,17z/data=!3m1!4b1!4m5!3m4!1s0x30c19539309a5e31:0x13c8bf6b41525bc0!8m2!3d16.8476269!4d96.1199804"
                            target="_blank">
                            No. 204, Level 8, The Leaf Office Tower, Dhamma Thukha Kyaung Street, Hlaing Township, Yangon
                        </a>
                    </div>
                </div>

                <div class="custom-list phone">
                    <div class="contact-item">
                        <h3>phone</h3>
                        <a href="tel:09772668899">09 772 66 88 99</a>
                    </div>
                </div>
            </div>

            <div class="contact-card">
                <h3>Pyay Office</h3>

                <div class="custom-list address">
                    <div class="contact-item">
                        <h3>address</h3>
                        <p>အမှတ် 1398၊ အနောက်စောင်းတန်းလမ်း၊ ဆံတော်ရပ်ကွက်၊ ပြည်မြို့။</p>
                    </div>
                </div>

                <div class="custom-list phone">
                    <div class="contact-item">
                        <h3>phone</h3>
                        <a href="tel:09443443916">09 443443916</a>, <a href="tel:09443443917">09 443443917</a>
                    </div>
                </div>
            </div>

            <div class="contact-card">
                <h3>Mandalay Office</h3>

                <div class="custom-list address">
                    <div class="contact-item">
                        <h3>address</h3>
                        <p>Ka-2/No.85(Ka), 111st, Between 66 x 67 St, Chan Aye Thar Si Township, Mandalay</p>
                    </div>
                </div>

                <div class="custom-list phone">
                    <div class="contact-item">
                        <h3>phone</h3>
                        <a href="tel:09405108866">09 405108866</a>, <a href="tel:09405108877">09 405108877</a>
                    </div>
                </div>
            </div>

            <div class="contact-card">
                <div class="custom-list during">
                    <div class="contact-item">
                        <h3>during</h3>
                        <p>Mon-Sat: 9:00am - 5:30pm</p>
                    </div>
                </div>
            </div>
        </div>
        <div class="contact-form">
            <div class="apn-form_input">
                <label for="name">Your Name( required )</label>
                <input type="text" name="name"
                                :class="{'error': posting && error.name}"
                                @keyup="onChange('name')"
                                v-model="user.name" required>
            </div>
            <div class="apn-form_input">
                <label for="email">Your Email( required )</label>
                <input type="email" name="email"
                                :class="{'error': posting && error.email}"
                                @keyup="onChange('email')"
                                v-model="user.email" required>
            </div>
            <div class="apn-form_input">
                <label for="phone">Your Phone( required )</label>
                <input type="phone" name="phone"
                                :class="{'error': posting && error.phone}"
                                @keyup="onChange('phone')"
                                v-model="user.phone" required>
            </div>
            <div class="apn-form_input">
                <label for="subject">Subject( required )</label>
                <input type="text" name="subject"
                                :class="{'error': posting && error.subject}"
                                @keyup="onChange('subject')"
                                v-model="user.subject" required>
            </div>
            <div class="apn-form_input apn-form_input--message">
                <label for="subject">Your Message</label>
                <textarea rows="8" v-model="user.message"></textarea>
            </div>
            <button class="apn-btn--more"  :disabled="posting" @click="postMessage">send</button>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ApnContactForm',
    data() {
        return {
            user: {
                name: '',
                email: '',
                phone: '',
                subject: '',
                message: '',
            },
            error: {
                name: true,
                email: true,
                phone: true,
                subject: true,
            },
            posting: false,
            message: '',
        }
    },
    methods: {
        async postMessage() {
            this.posting = true
            if (this.error.name || this.error.email || this.error.phone || this.error.subject) return
            this.message = 'Sending..'
            const post = (await this.axios.post('https://admin.myanmarapn.com/api/contactus-send', this.user)).data
            console.log(post)
            if (post.status) {
                this.reset()
            } else {
                this.message = 'Error Occur!'
            }
            this.posting = false
        },
        onChange(val) {
            this.posting = false
            if (val == "name") {
                this.error.name =
                    this.user.name && this.user.name.length > 3 ? false : true;
            } else if (val == "email") {
                const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                this.error.email =
                    this.user.email && re.test(this.user.email.toLowerCase())
                        ? false
                        : true;
            } else if (val == "phone") {
                this.error.phone =
                    this.user.phone
                        ? false
                        : true;
            } else if (val == "subject") {
                this.error.subject =
                    this.user.subject && this.user.subject.length > 4
                        ? false
                        : true;
            }
        },
        reset() {
            this.message = 'Success!',
            this.user = {
                name: '',
                email: '',
                phone: '',
                subject: '',
                message: '',
            }
        }
    }
}
</script>

<style scoped lang="scss">
.apn-contact {
    width: 100%;
    max-width: 900px;
    margin: 0 auto;
    padding: 0 10px;
    display: flex;
    flex-wrap: wrap;
    padding: 20px 10px;
    @media (min-width: 768px) {
        padding: 20px 10px;
    }
    .message--msg {
        width: 100%;
        text-align: center;
    }
    .quick-contact {
        width: 100%;
        padding: 20px 0;
        @media (min-width: 768px) {
            width: 45%;
        }

        .contact-card {

            margin-bottom: 0.5rem;

            h3 {
                color: #666;
                padding: 5px 10px;
                text-transform: uppercase;  
            }

            .address {
                &::before {
                    content: '';
                    display: block;
                    width: 20px;
                    min-width: 20px;
                    height: 20px;
                    margin-right: 10px;
                    margin-top: 2px;
                    background-size: contain;
                    background-position: center;
                    background-repeat: no-repeat;
                }
                &.address::before {
                    background-image: url(../assets/icons/address.png);
                }

                .contact-item {
                    h3 {
                        text-transform: uppercase;
                        font-size: 14px;
                        margin: 0;
                        padding: 5px 0;
                    }
                    a, p {
                        color: var(--body-color);
                        margin: 0;
                        padding: 0;
                        text-decoration: none;
                        font-weight: 400;
                    }
                }
            }

            .phone {
                &::before {
                    content: '';
                    display: block;
                    width: 20px;
                    min-width: 20px;
                    height: 20px;
                    margin-right: 10px;
                    margin-top: 2px;
                    background-size: contain;
                    background-position: center;
                    background-repeat: no-repeat;
                }
                &.phone::before {
                    background-image: url(../assets/icons/phone-call.png);
                }

                .contact-item {
                    h3 {
                        text-transform: uppercase;
                        font-size: 14px;
                        margin: 0;
                        padding: 5px 0;
                    }
                    a, p {
                        color: var(--body-color);
                        margin: 0;
                        padding: 0;
                        text-decoration: none;
                        font-weight: 400;
                    }
                }
            }

            .during {
                &::before {
                    content: '';
                    display: block;
                    width: 20px;
                    min-width: 20px;
                    height: 20px;
                    margin-right: 10px;
                    margin-top: 2px;
                    background-size: contain;
                    background-position: center;
                    background-repeat: no-repeat;
                }
                &.phone::before {
                    background-image: url(../assets/icons/phone-call.png);
                }

                .contact-item {
                    h3 {
                        text-transform: uppercase;
                        font-size: 14px;
                        margin: 0;
                        padding: 5px 0;
                    }
                    a, p {
                        color: var(--body-color);
                        margin: 0;
                        padding: 0;
                        text-decoration: none;
                        font-weight: 400;
                    }
                }
            }

        }

        .custom-list {
            padding: 10px;
            display: flex;

            &::before {
                content: '';
                display: block;
                width: 24px;
                min-width: 24px;
                height: 24px;
                margin-right: 10px;
                margin-top: 2px;
                background-size: contain;
                background-position: center;
                background-repeat: no-repeat;
            }
            &.address::before {
                background-image: url(../assets/icons/address.png);
            }
            &.call-us::before {
                background-image: url(../assets/icons/phone-call.png);
                background-size: 20px;
            }
            &.during::before {
                background-image: url(../assets/icons/clock.png);
                background-size: 20px;
            }

            .custom-list_item {
                h3 {
                    text-transform: uppercase;
                    font-size: 16px;
                    margin: 0;
                    padding: 5px 0;
                }
                a, p {
                    color: var(--body-color);
                    margin: 0;
                    padding: 0;
                    text-decoration: none;
                    font-weight: 400;
                }
            }
        }
    }

    .contact-form {
        width: 100%;
        padding: 20px 0;
        display: flex;
        flex-direction: column;
        @media (min-width: 768px) {
            width: 55%;
        }
        .apn-form_input {
            padding: 0 10px;
            margin-bottom: 20px;
            label {
                font-size: 14px;
                color: #666;
                padding: 5px 0;
                display: block;
            }
            input, textarea {
                width: 100%;
                min-height: 45px;
                background-color: transparent;
                border: 1px solid #aaa;
                border-radius: 4px;
                resize: none;
                padding: 0 15px;
                &:focus {
                    border: 1px solid var(--primary);
                    outline: none;
                }
                &.error {
                    border-color: #f00;
                }
            }
            textarea {
                padding: 15px;
            }
        }
        .apn-btn--more {
            align-self: flex-end;
            // Remove Later
            cursor: not-allowed;
            background-color: var(--primary);
            color: #fff;
            margin: 10px;
            &:disabled {
                opacity: .5;
            }
        }
    }
}
</style>
